import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManifestdetailsComponent } from './manifestdetails.component';
import { ConnotePickerModule } from '../run/connote-picker/connote-picker.module'; 
import { ConnoteSitePickerModule } from "../run/connote-site-picker/connote-site-picker.module";
import { RunTaskSearchComponentModule } from '../run/run-tasks/run-task-search/run-task-search.component.module';
import { NgxLoadingModule } from 'ngx-loading';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NguiMapModule } from '@ngui/map';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxGeoautocompleteModule } from "ngx-geoautocomplete-v2";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { FileUploaderModule } from '../../control/file-uploader/file-uploader.module';
import { MyDatePickerModule } from 'mydatepicker';
import {  NgbModalModule } from "@ng-bootstrap/ng-bootstrap";
import { DragulaModule } from 'ng2-dragula';




export const routes: Routes = [
 { path: 'manifestdetails/:id', component: ManifestdetailsComponent, data: { breadcrumb: 'Dispatch Details' } }
];

let google_map_api_nicola = localStorage.getItem('ngx_google_map_api_nicola') || '';


@NgModule({
  declarations: [
    ManifestdetailsComponent
  ],
  imports: [
    CommonModule,
    NgxLoadingModule,
    RunTaskSearchComponentModule,
    RouterModule.forChild(routes),
    FormsModule, 
    ReactiveFormsModule,
    NguiMapModule.forRoot({apiUrl: `https://maps.google.com/maps/api/js?key=${google_map_api_nicola}`}),
    NgxPaginationModule,
    NgxGeoautocompleteModule.forRoot(),
    NgbModule,
    MultiselectDropdownModule,
    ConnotePickerModule,
    ConnoteSitePickerModule,
    FileUploaderModule,
    MyDatePickerModule,
    NgbModalModule,
    DragulaModule.forRoot()
  ],
  exports: [ManifestdetailsComponent]
})
export class ManifestdetailsModule { }
